import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { Fonts } from '../../../../play-core/styles/Fonts';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx } from "react/jsx-runtime";
export const Label = ({
  text,
  backgroundColor,
  fontColor,
  className
}) => /*#__PURE__*/_jsx(Fragment, {
  children: text && /*#__PURE__*/_jsx(Layout, {
    backgroundColor: backgroundColor,
    className: className,
    children: /*#__PURE__*/_jsx(Text, {
      fontColor: fontColor,
      children: text
    })
  })
});
const Layout = styled.div.withConfig({
  displayName: "Label__Layout",
  componentId: "sc-11olivt-0"
})(["background-color:", ";display:inline-flex;justify-content:center;align-items:center;border-radius:2px;white-space:nowrap;padding:0 6px;width:fit-content;height:16px;", "{height:24px;}"], ({
  backgroundColor
}) => backgroundColor, Viewports.for('mediumUp'));
const Text = styled.span.withConfig({
  displayName: "Label__Text",
  componentId: "sc-11olivt-1"
})(["color:", ";", ";", "{", ";}"], ({
  fontColor
}) => fontColor, Fonts.medium(12), Viewports.for('mediumUp'), Fonts.medium(14));